import { Config } from '../../../config/index'
import React from 'react'
import styled from 'styled-components'

interface RadioInputProps {
  isChecked?: boolean
  label?: string
  onChange: (_: string) => void
  name?: string
  value?: string | number
  smallMargin?: boolean
  color?: {
    radioColor: string
    textColor: string
  }
}

export const RadioInput = ({
  isChecked,
  label,
  onChange,
  name,
  value,
  smallMargin = false,
  color = {
    radioColor: Config.palette.primary,
    textColor: Config.palette.primary,
  },
}: RadioInputProps) => {
  return (
    <Container
      smallMargin={smallMargin}
      onClick={(e) => {
        e.stopPropagation()
        onChange(value as string)
      }}
    >
      <Label color={color?.textColor} isChecked={isChecked}>
        <Input type="radio" name={name} />
        <Span color={color?.radioColor} isChecked={isChecked} />
        {label}
      </Label>
    </Container>
  )
}

const Container = styled.div<{ smallMargin?: boolean }>`
  margin-bottom: ${(props) => (props.smallMargin ? '0.4rem' : '1rem')};
  word-break: break-all;
  box-sizing: border-box;

  &:hover {
    opacity: 0.7;
  }
`

const Label = styled.div<{ color: string; isChecked?: boolean }>`
  display: flex;
  align-items: center;
  font-size: 1.6rem;
  cursor: pointer;
  position: relative;
  width: 100%;
  height: 100%;
  color: ${({ color }) => color};

  ${({ color, theme, isChecked }) =>
    color === theme.palette.primary &&
    isChecked &&
    `
    font-weight: bold;
    color: ${theme.palette.primary};
  `}
`

const Input = styled.input`
  display: none;
`
interface SpanProps {
  isChecked?: boolean
  color?: string
}

const Span = styled.span.attrs({
  className: 'mr-3',
})<SpanProps>`
  height: 1.4rem;
  width: 1.4rem;
  border: 0.2rem solid ${({ color }) => color};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &:after {
    content: '';
    display: block;
    height: calc(100% - 4px);
    width: calc(100% - 4px);
    border-radius: 50%;

    background-color: ${({ color }) => color};
    opacity: ${(props) => (props.isChecked ? 1 : 0)};
    transition: opacity 0.2s ease 0s;
  }
`
